import { colors } from '../../colors';
var address = {
  arrowColor: colors.deepOrange,
  textColor: colors.black,
  borderColor: colors.black,
  backgroundColor: colors.white
};
export default address;